/* =====================================================================
   BIES House — "Tu propio pack"  ·  lógica (preview)
   - Mini-cuestionario (objetivo + preferencia) → perfil.
   - MISMO motor de afinidad del Welcome Survey (AFFINITY × SIGNAL_WEIGHTS).
   - Monta una caja personalizada (top-N) → PROPUESTA + AJUSTABLE.
   - Compra única (cart/add) o suscripción Club BIES (~X€/día).
   ===================================================================== */
(function () {
  'use strict';

  var CFG = Object.assign({
    catalog: [], boxSize: 4, subscriptionDiscount: 10,
    subscriptionEnabled: false, sellingPlanId: null,
    cartUrl: '/cart', clubUrl: '/pages/club-bies'
  }, window.BIES_TPP_CONFIG || {});

  // La suscripción solo se ofrece si el flag está ON y hay selling plan real.
  var SUB_ON = !!(CFG.subscriptionEnabled && CFG.sellingPlanId);

  // ── Afinidad de cada producto (por handle) — verbatim del Welcome Survey ──
  var AFFINITY = {
    'bies-endulzante-liquido':                          { azucar:4, clinico:4, cafe:2, reposteria:2, cocina:3, refrescos:1, explorar:1 },
    'matcha-bies-house':                                { te:4, cafe:2, ritual:3, energia:2, explorar:1 },
    'cafe-energizante-bies-house':                      { energia:4, energeticas:4, cafe:3, refrescos:2, deporte:1, pre:2 },
    'batido-de-proteina-sabor-chocolate':               { proteina:4, deporte:3, post:3, fuerza:3, dulce:1 },
    'batido-de-proteina-bies-house-sabor-frutos-rojos': { proteina:4, deporte:3, post:3, cardio:3 },
    'pancakes-bies-house':                              { desayuno:4, dulce:2, proteina:2, deporte:2, snack:1, postre:2 },
    'granola-bies-house':                              { desayuno:4, snack:3, fibra:3, explorar:1 },
    'granola-chocolate-bies-house':                     { desayuno:3, dulce:4, postre:3, snack:2, reposteria:2 },
    'bebida-instantanea-mix':                           { refrescos:4, hidratacion:4, zumos:3, energeticas:1, snack:1, explorar:2 }
  };

  // ── Señales del mini-cuestionario → pesos por etiqueta de afinidad ──
  var SIGNAL_WEIGHTS = {
    // Q1 · objetivo
    stevia:'azucar:4', clinico:'azucar:3,clinico:4', desayuno:'desayuno:3,snack:1',
    deporte:'deporte:3,proteina:2', refrescos:'refrescos:3,hidratacion:1', explorando:'explorar:3',
    // Q2 · preferencia
    p_cafe:'cafe:3,energia:1', p_te:'te:4,ritual:2', p_dulce:'dulce:3,postre:2',
    p_proteina:'proteina:3,deporte:1', p_hidratacion:'hidratacion:3,refrescos:1', p_fibra:'fibra:3,desayuno:1'
  };

  var Q1 = [
    ['stevia','Quitar el azúcar de mi día a día'],
    ['desayuno','Un desayuno o snack más sano'],
    ['deporte','Proteína natural para deporte'],
    ['refrescos','Reemplazar refrescos y bebidas azucaradas'],
    ['clinico','Diabetes o prediabetes (mía o de alguien cercano)'],
    ['explorando','Estoy explorando']
  ];
  var Q2 = [
    ['p_cafe','El café'],
    ['p_te','El té / matcha'],
    ['p_dulce','Lo dulce (sin azúcar)'],
    ['p_proteina','La proteína'],
    ['p_hidratacion','Las bebidas / hidratación'],
    ['p_fibra','La fibra / cereales']
  ];
  var EDAD = [ ['18-29','18–29'], ['30-44','30–44'], ['45-59','45–59'], ['60+','60 o más'] ];
  var SEXO = [ ['mujer','Mujer'], ['hombre','Hombre'], ['otro','Otro / prefiero no decir'] ];
  var BOX_TITLE = {
    stevia:'Tu caja para quitar el azúcar', clinico:'Tu caja para controlar el azúcar',
    desayuno:'Tu caja para desayunos sanos', deporte:'Tu caja para rendir',
    refrescos:'Tu caja para hidratarte mejor', explorando:'Tu caja para descubrir BIES'
  };

  // ── Explicación "para tontos": qué es cada producto (1 línea) ──
  var PRODUCT_BLURB = {
    'bies-endulzante-liquido': 'Endulza tu café, postres o lo que quieras sin azúcar. Unas gotas y listo.',
    'matcha-bies-house': 'Energía suave y sin nervios, tipo café pero más tranquilo. Ideal por la mañana.',
    'cafe-energizante-bies-house': 'Café con energía que dura, sin bajón. Ya viene endulzado con stevia.',
    'batido-de-proteina-sabor-chocolate': 'Proteína para recuperar tras entrenar, sabor chocolate. Como un batido rico.',
    'batido-de-proteina-bies-house-sabor-frutos-rojos': 'Proteína sabor frutos rojos para después del deporte. Refrescante.',
    'pancakes-bies-house': 'Tortitas proteicas para un desayuno que llena sin remordimientos. Fáciles de hacer.',
    'granola-bies-house': 'Cereales con fibra para desayunar o picar. Sacian y van bien para el intestino.',
    'granola-chocolate-bies-house': 'La misma granola pero con chocolate. Un capricho dulce sin azúcar.',
    'bebida-instantanea-mix': 'Bebida con sabor para hidratarte, en vez de refrescos azucarados.'
  };
  // ── Beneficio (1 bullet) por producto → alimenta "¿Por qué este pack?" de forma dinámica ──
  var PRODUCT_BENEFIT = {
    'bies-endulzante-liquido': 'Endulzas igual, pero sin azúcar ni químicos',
    'matcha-bies-house': 'Energía suave y sin nervios, tipo café tranquilo',
    'cafe-energizante-bies-house': 'Energía que dura, sin bajón a media mañana',
    'batido-de-proteina-sabor-chocolate': 'Recuperas mejor después de entrenar',
    'batido-de-proteina-bies-house-sabor-frutos-rojos': 'Proteína para después del deporte',
    'pancakes-bies-house': 'Un desayuno que llena sin remordimientos',
    'granola-bies-house': 'Fibra que sacia y va bien para el intestino',
    'granola-chocolate-bies-house': 'Un capricho dulce, pero sin azúcar',
    'bebida-instantanea-mix': 'Te hidratas mejor, sin refrescos azucarados'
  };
  // ── Explicación "para tontos": para qué es tu pack + beneficios, por objetivo ──
  var OBJETIVO_INFO = {
    stevia:    { intro:'Tu pack está pensado para sacar el azúcar de tu día sin renunciar al dulce.',
      benefits:['Endulzas igual, pero sin azúcar ni químicos','Cuidas tu salud sin pasarlo mal','Para el día a día: café, postres y desayuno'] },
    clinico:   { intro:'Tu pack está pensado para controlar el azúcar en tu día a día, de forma fácil.',
      benefits:['Sin azúcar ni edulcorantes raros','Stevia natural cultivada en España','Vale para ti o para quien cuidas'] },
    desayuno:  { intro:'Tu pack está pensado para desayunos y snacks sanos que de verdad llenan.',
      benefits:['Empiezas el día con energía estable','Fibra y proteína que sacian','Sin bajones a media mañana'] },
    deporte:   { intro:'Tu pack está pensado para acompañar tu entrenamiento con proteína natural.',
      benefits:['Recuperas mejor después de entrenar','Proteína de calidad y buen sabor','Energía para rendir'] },
    refrescos: { intro:'Tu pack está pensado para dejar los refrescos azucarados sin echarlos de menos.',
      benefits:['Bebidas con sabor, pero sin azúcar','Te hidratas mejor','Adiós a los picos de azúcar'] },
    explorando:{ intro:'Tu pack está pensado para descubrir lo mejor de BIES de una sola vez.',
      benefits:['Pruebas un poco de todo','Lo más vendido y querido','Sin azúcar ni edulcorantes químicos'] }
  };

  // ── Motor: señales → {tag:peso}; puntúa catálogo; top-N ──
  function collectSignals(ans) {
    var acc = {};
    [ans.q1, ans.q2].forEach(function (v) {
      var spec = SIGNAL_WEIGHTS[v]; if (!spec) return;
      spec.split(',').forEach(function (pair) {
        var kv = pair.split(':'); acc[kv[0]] = (acc[kv[0]] || 0) + Number(kv[1]);
      });
    });
    return acc;
  }
  function rank(ans) {
    var signals = collectSignals(ans);
    return (CFG.catalog || []).map(function (p) {
      var aff = AFFINITY[p.handle] || {}, score = 0;
      for (var t in aff) { if (signals[t]) score += signals[t] * aff[t]; }
      return { p: p, score: score };
    }).sort(function (a, b) { return b.score - a.score; });
  }
  function buildBox(ans) {
    var ranked = rank(ans);
    var picked = ranked.filter(function (r) { return r.score > 0; }).slice(0, CFG.boxSize).map(function (r) { return r.p.handle; });
    // relleno con "core" si el perfil puntuó poco
    ['bies-endulzante-liquido','granola-bies-house','matcha-bies-house'].forEach(function (h) {
      if (picked.length >= CFG.boxSize) return;
      if (picked.indexOf(h) < 0 && byHandle(h)) picked.push(h);
    });
    return picked;
  }
  function byHandle(h) { return (CFG.catalog || []).filter(function (p) { return p.handle === h; })[0]; }

  // ── Dinero (formato €) ──
  function eur(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function perDay(cents) { return (cents / 100 / 30).toFixed(2).replace('.', ',') + ' €'; }

  // ── State ──
  var root, answers = { q1: null, q2: null, edad: null, sexo: null, nombre: '', email: '' }, selected = [];

  function h(tag, cls, html) {
    var el = document.createElement(tag); if (cls) el.className = cls; if (html != null) el.innerHTML = html; return el;
  }

  // ── ¿Tenemos info suficiente del cliente para captar su perfil? ──
  function getKnownProfile() {
    try { var qs = new URLSearchParams(location.search);
      if (qs.get('perfil')) return { q1: qs.get('perfil'), q2: qs.get('pref') || null, src: 'demo' }; } catch (e) {}
    var keys = ['bies_profile', 'bies_ws_profile']; // pack previo · respuestas del Welcome Survey
    for (var i = 0; i < keys.length; i++) {
      try { var s = JSON.parse(localStorage.getItem(keys[i]) || 'null');
        if (s && (s.q1 || s.email)) return { q1: s.q1 || null, q2: s.q2 || null, edad: s.edad || null, sexo: s.sexo || null, nombre: s.nombre || '', email: s.email || '', fnac: s.fnac || null, src: keys[i] }; } catch (e) {}
    }
    return null;
  }
  function saveProfile() {
    try { localStorage.setItem('bies_profile', JSON.stringify({ q1: answers.q1, q2: answers.q2, edad: answers.edad, sexo: answers.sexo, nombre: answers.nombre, email: answers.email, fnac: answers.fnac })); } catch (e) {}
  }
  // ── Manda los datos al twin (Klaviyo) — best-effort ──
  function kIdentify() {
    try {
      var props = { '$email': answers.email, 'BiesTPP_Goal': answers.q1 || null, 'BiesTPP_Pref': answers.q2 || null,
        'BiesTPP_Edad': answers.edad || null, 'BiesTPP_FNac': answers.fnac || null, 'BiesTPP_Sexo': answers.sexo || null, 'BiesTPP_Source': 'Tu propio pack' };
      if (answers.nombre) props['$first_name'] = answers.nombre;
      window.klaviyo = window.klaviyo || []; window.klaviyo.push(['identify', props]);
      window._learnq = window._learnq || []; window._learnq.push(['identify', props]);
    } catch (e) {}
  }
  function goToBox() { kIdentify(); saveProfile(); selected = buildBox(answers); renderBox(false); }

  // ── Texto libre: "cuéntanos qué necesitas" → perfil (por palabras clave) ──
  function analyzeText(txt) {
    var t = (txt || '').toLowerCase(), q1 = 'explorando', q2 = null;
    if (/diabet|gluc|prediabet|az[uú]car en sangre/.test(t)) q1 = 'clinico';
    else if (/deport|prote|gym|entren|m[uú]sculo|fuerza|correr|running|pesas/.test(t)) q1 = 'deporte';
    else if (/refresco|coca|cola|hidrat|zumo|bebida/.test(t)) q1 = 'refrescos';
    else if (/desayun|granola|merienda|snack|tortita|pancake/.test(t)) q1 = 'desayuno';
    else if (/az[uú]car|endulz|dulce|stevia|edulcor/.test(t)) q1 = 'stevia';
    if (/caf[eé]/.test(t)) q2 = 'p_cafe';
    else if (/matcha|t[eé]/.test(t)) q2 = 'p_te';
    else if (/prote/.test(t)) q2 = 'p_proteina';
    else if (/fibra|intestin|digest/.test(t)) q2 = 'p_fibra';
    else if (/hidrat|refresco|bebida/.test(t)) q2 = 'p_hidratacion';
    else if (/dulce|postre|choco/.test(t)) q2 = 'p_dulce';
    return { q1: q1, q2: q2 };
  }

  // ── Pantalla "no te conocemos": contar o responder preguntas ──
  function renderAsk() {
    root.innerHTML = '';
    var card = h('div', 'tpp-quiz');
    card.appendChild(h('h3', 'tpp-q', '¿Qué buscas en BIES?'));
    card.appendChild(h('p', 'tpp-ask__lead', 'Cuéntanoslo en una frase y te montamos tu caja. O responde unas preguntas rápidas.'));
    var ta = h('textarea', 'tpp-ask__ta'); ta.rows = 3;
    ta.placeholder = 'Ej.: "Quiero quitar el azúcar y soy diabético" · "busco proteína para el gym" · "un desayuno sano"';
    card.appendChild(ta);
    var go = h('button', 'tpp-build', 'Montar mi pack con esto'); go.type = 'button';
    card.appendChild(go);
    card.appendChild(h('div', 'tpp-or', 'o'));
    var quizBtn = h('button', 'tpp-altbtn', 'Prefiero responder unas preguntas rápidas'); quizBtn.type = 'button';
    card.appendChild(quizBtn);
    var back = h('button', 'tpp-altbtn', '← Atrás'); back.type = 'button'; card.appendChild(back);
    root.appendChild(card);
    go.addEventListener('click', function () {
      var v = (ta.value || '').trim();
      if (!v) { ta.focus(); return; }
      var a = analyzeText(v); answers.q1 = a.q1; answers.q2 = a.q2; goToBox();
    });
    quizBtn.addEventListener('click', renderQuiz);
    back.addEventListener('click', renderDatos);
  }

  // ── Paso 1: cuestionario ──
  function renderQuiz() {
    root.innerHTML = '';
    var card = h('div', 'tpp-quiz');
    card.appendChild(h('h3', 'tpp-q', '¿Qué te ha traído a BIES?'));
    var g1 = h('div', 'tpp-opts');
    Q1.forEach(function (o) {
      var b = h('button', 'tpp-opt', o[1]); b.type = 'button'; b.dataset.q = 'q1'; b.dataset.v = o[0];
      if (answers.q1 === o[0]) b.classList.add('is-sel');
      g1.appendChild(b);
    });
    card.appendChild(g1);

    card.appendChild(h('h3', 'tpp-q tpp-q2', '¿Qué es lo que más te gusta?'));
    var g2 = h('div', 'tpp-opts');
    Q2.forEach(function (o) {
      var b = h('button', 'tpp-opt', o[1]); b.type = 'button'; b.dataset.q = 'q2'; b.dataset.v = o[0];
      if (answers.q2 === o[0]) b.classList.add('is-sel');
      g2.appendChild(b);
    });
    card.appendChild(g2);

    var cta = h('button', 'tpp-build', 'Montar mi pack'); cta.type = 'button'; cta.disabled = !(answers.q1 && answers.q2);
    card.appendChild(cta);
    var back = h('button', 'tpp-altbtn', '← Atrás'); back.type = 'button'; card.appendChild(back);
    root.appendChild(card);

    root.querySelectorAll('.tpp-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.dataset.q;
        answers[q] = b.dataset.v;
        root.querySelectorAll('.tpp-opt[data-q="' + q + '"]').forEach(function (x) { x.classList.remove('is-sel'); });
        b.classList.add('is-sel');
        cta.disabled = !(answers.q1 && answers.q2);
      });
    });
    cta.addEventListener('click', goToBox);
    back.addEventListener('click', renderAsk);
  }

  // ── Edad a partir de la fecha de nacimiento ──
  function ageFrom(d) {
    if (!d) return null;
    var b = new Date(d); if (isNaN(b.getTime())) return null;
    var t = new Date(), a = t.getFullYear() - b.getFullYear();
    if (t.getMonth() < b.getMonth() || (t.getMonth() === b.getMonth() && t.getDate() < b.getDate())) a--;
    return (a >= 0 && a < 120) ? a : null;
  }

  // ── Paso 1 (de entrada, SIEMPRE): tus datos — nombre, email, sexo, fecha de nacimiento ──
  function renderDatos() {
    root.innerHTML = '';
    var card = h('div', 'tpp-quiz');
    card.appendChild(h('h3', 'tpp-q', 'Empecemos por ti'));
    card.appendChild(h('p', 'tpp-ask__lead', 'Con estos datos afinamos tu pack ideal y te lo enviamos a tu correo, con un 15% de bienvenida.'));

    card.appendChild(h('label', 'tpp-label', 'Nombre'));
    var iName = h('input', 'tpp-input'); iName.type = 'text'; iName.placeholder = 'Tu nombre'; iName.autocomplete = 'given-name'; if (answers.nombre) iName.value = answers.nombre;
    card.appendChild(iName);

    card.appendChild(h('label', 'tpp-label', 'Email'));
    var iMail = h('input', 'tpp-input'); iMail.type = 'email'; iMail.placeholder = 'tu@email.com'; iMail.autocomplete = 'email'; iMail.inputMode = 'email'; if (answers.email) iMail.value = answers.email;
    card.appendChild(iMail);
    var err = h('p', 'tpp-err', 'Revisa el email, no parece válido.'); card.appendChild(err);

    card.appendChild(h('label', 'tpp-label', 'Sexo'));
    var gs = h('div', 'tpp-opts tpp-opts--wrap');
    SEXO.forEach(function (o) { var b = h('button', 'tpp-opt tpp-opt--chip', o[1]); b.type = 'button'; b.dataset.f = 'sexo'; b.dataset.v = o[0]; if (answers.sexo === o[0]) b.classList.add('is-sel'); gs.appendChild(b); });
    card.appendChild(gs);

    card.appendChild(h('label', 'tpp-label', 'Fecha de nacimiento'));
    var iFnac = h('input', 'tpp-input'); iFnac.type = 'date'; iFnac.max = new Date().toISOString().slice(0, 10); if (answers.fnac) iFnac.value = answers.fnac;
    card.appendChild(iFnac);

    card.appendChild(h('p', 'tpp-priv', 'Solo usamos tus datos para darte tu pack y ofertas que te interesen. Te puedes dar de baja en un clic.'));
    var cta = h('button', 'tpp-build', 'Continuar'); cta.type = 'button'; cta.disabled = true;
    card.appendChild(cta);
    root.appendChild(card);

    function emailOk() { return /\S+@\S+\.\S+/.test((iMail.value || '').trim()); }
    function ready() { return emailOk() && answers.sexo && (iFnac.value || answers.fnac); }
    function upd() { cta.disabled = !ready(); }
    iName.addEventListener('input', function () { answers.nombre = iName.value.trim(); });
    iMail.addEventListener('input', function () { err.classList.remove('is-on'); answers.email = iMail.value.trim(); upd(); });
    iFnac.addEventListener('change', function () { answers.fnac = iFnac.value; answers.edad = ageFrom(iFnac.value); upd(); });
    gs.querySelectorAll('.tpp-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        answers.sexo = b.dataset.v;
        gs.querySelectorAll('.tpp-opt').forEach(function (x) { x.classList.remove('is-sel'); });
        b.classList.add('is-sel'); upd();
      });
    });
    upd();
    cta.addEventListener('click', function () {
      if (!emailOk()) { err.classList.add('is-on'); iMail.focus(); return; }
      answers.nombre = (iName.value || '').trim(); answers.email = (iMail.value || '').trim();
      answers.fnac = iFnac.value || answers.fnac; answers.edad = ageFrom(answers.fnac);
      kIdentify(); saveProfile(); renderAsk();
    });
  }

  // ── Paso 2: caja propuesta + ajustable ──
  function renderBox(isAuto) {
    root.innerHTML = '';
    var wrap = h('div', 'tpp-box');

    var head = h('div', 'tpp-box__head');
    head.appendChild(h('h3', 'tpp-box__title', BOX_TITLE[answers.q1] || 'Tu pack a medida'));
    var redo = h('button', 'tpp-redo', '↺ Empezar de cero'); redo.type = 'button';
    head.appendChild(redo);
    wrap.appendChild(head);
    if (isAuto) wrap.appendChild(h('div', 'tpp-auto', '✓ Te lo hemos montado solo, según lo que ya sabemos de ti. Ajústalo si quieres.'));
    var info = OBJETIVO_INFO[answers.q1];
    if (info) {
      var greet = answers.nombre ? (answers.nombre + ', ' + info.intro.charAt(0).toLowerCase() + info.intro.slice(1)) : info.intro;
      wrap.appendChild(h('p', 'tpp-box__intro', greet));
    }
    wrap.appendChild(h('p', 'tpp-box__note', 'Esto es lo que te montamos según tu perfil. Quita lo que no quieras o añade más abajo.'));

    // cards seleccionadas
    var grid = h('div', 'tpp-grid');
    selected.forEach(function (handle) {
      var p = byHandle(handle); if (!p) return;
      var c = h('div', 'tpp-card');
      c.innerHTML =
        '<button class="tpp-card__x" type="button" aria-label="Quitar">×</button>' +
        (p.image ? '<div class="tpp-card__img"><img src="' + p.image + '" alt="' + (p.name || '') + '"></div>' : '<div class="tpp-card__img tpp-card__img--ph"></div>') +
        '<div class="tpp-card__name">' + p.name + '</div>' +
        '<div class="tpp-card__price">' + eur(p.price) + '</div>' +
        '<div class="tpp-card__blurb">' + (PRODUCT_BLURB[handle] || '') + '</div>';
      c.querySelector('.tpp-card__x').addEventListener('click', function () {
        selected = selected.filter(function (x) { return x !== handle; }); renderBox();
      });
      grid.appendChild(c);
    });
    wrap.appendChild(grid);
    if (!selected.length) {
      var empty = h('p', 'tpp-box__empty', 'Tu caja está vacía. Añade productos abajo para montar tu pack.');
      empty.style.cssText = 'text-align:center;opacity:.65;padding:18px 0;';
      wrap.appendChild(empty);
    }

    // ¿Por qué este pack? — beneficios calculados desde los productos de la caja
    // (se recalcula en cada renderBox → se actualiza al añadir/quitar productos)
    var packBenefits = [];
    selected.forEach(function (handle) {
      var b = PRODUCT_BENEFIT[handle];
      if (b && packBenefits.indexOf(b) < 0) packBenefits.push(b);
    });
    if (!packBenefits.length && selected.length && info && info.benefits) packBenefits = info.benefits.slice(); // fallback SOLO si hay productos pero ninguno mapeado (caja vacía → sin beneficios)
    packBenefits = packBenefits.slice(0, 4);
    if (packBenefits.length) {
      var ben = h('div', 'tpp-benefits');
      ben.appendChild(h('p', 'tpp-benefits__t', '¿Por qué este pack?'));
      var ul = h('ul', 'tpp-benefits__list');
      packBenefits.forEach(function (b) { ul.appendChild(h('li', null, b)); });
      ben.appendChild(ul);
      wrap.appendChild(ben);
    }

    // añadir más (resto del catálogo, ordenado por afinidad)
    var rest = rank(answers).map(function (r) { return r.p; }).filter(function (p) { return selected.indexOf(p.handle) < 0; });
    if (rest.length) {
      wrap.appendChild(h('p', 'tpp-add__label', 'Añadir a tu caja'));
      var addRow = h('div', 'tpp-add');
      rest.forEach(function (p) {
        var a = h('button', 'tpp-add__item', '<span>+ ' + p.name + '</span><span class="tpp-add__p">' + eur(p.price) + '</span>');
        a.type = 'button';
        a.addEventListener('click', function () { selected.push(p.handle); renderBox(); });
        addRow.appendChild(a);
      });
      wrap.appendChild(addRow);
    }

    // resumen + CTAs — la suscripción SOLO se pinta si SUB_ON (selling plan real detrás)
    var total = selected.reduce(function (s, hh) { var p = byHandle(hh); return s + (p ? p.price : 0); }, 0);
    var subTotal = Math.round(total * (1 - CFG.subscriptionDiscount / 100));
    var bar = h('div', 'tpp-bar');
    var pricesHtml = '<div class="tpp-bar__once"><span>' + (SUB_ON ? 'Compra única' : 'Tu pack') + '</span><b>' + eur(total) + '</b></div>';
    var btnsHtml = '<button class="tpp-buy tpp-buy--once" type="button">Comprar mi pack</button>';
    if (SUB_ON) {
      pricesHtml += '<div class="tpp-bar__sub"><span>Suscripción · ' + CFG.subscriptionDiscount + '% dto</span><b>' + eur(subTotal) + '/mes</b>' +
        '<em>≈ ' + perDay(subTotal) + ' al día</em></div>';
      btnsHtml += '<button class="tpp-buy tpp-buy--sub" type="button">Suscribirme · ' + perDay(subTotal) + '/día</button>';
    }
    bar.innerHTML =
      '<div class="tpp-bar__prices">' + pricesHtml + '</div>' +
      '<div class="tpp-bar__btns">' + btnsHtml + '</div>';
    wrap.appendChild(bar);
    root.appendChild(wrap);

    if (!selected.length) { bar.querySelectorAll('.tpp-buy').forEach(function (b) { b.disabled = true; }); }
    redo.addEventListener('click', renderDatos);
    bar.querySelector('.tpp-buy--once').addEventListener('click', function () { addToCart(false); });
    var subBtn = bar.querySelector('.tpp-buy--sub');
    if (subBtn) subBtn.addEventListener('click', function () { addToCart(true); });
  }

  // ── Tras el add-to-cart: confirmación visible + CTA para seguir la compra ──
  // El tema tiene un cart drawer propio (window.biesCartDrawer, expuesto para
  // triggers externos) que el resto del sitio usa siempre que se añade algo
  // al carrito. Aquí replicamos su MISMO patrón interno (fetch /cart.js →
  // processCart → open({skipUpdate:true}), igual que el intercept de
  // formularios en bies-cart-drawer.js) en vez del redirect silencioso de
  // antes: abrimos el drawer al instante con datos frescos (feedback
  // inmediato, sin abandonar la página) y dejamos SIEMPRE visible un botón
  // explícito "Sigue la compra por aquí" por si el drawer no está disponible
  // o el cliente lo cierra sin querer.
  // Nota: open() sin skipUpdate NO sirve aquí — el drawer cachea su propio
  // updateCart() ~30s y como el pack se añade via fetch directo (no via
  // submit de formulario, que es lo único que el drawer intercepta) su
  // caché no se entera del pack recién añadido. Por eso el fetch manual.
  // (8-sep) El add ya deja el drawer abierto y reconciliado (ver addToCart);
  // este CTA solo lo reabre si el cliente lo cerró. open() sin skipUpdate
  // refresca por la cola serie si su caché (30s) caducó.
  function goToCart() {
    try {
      if (window.biesCartDrawer && typeof window.biesCartDrawer.open === 'function') {
        window.biesCartDrawer.open();
        return;
      }
    } catch (e) {}
    window.location.href = CFG.cartUrl;
  }
  function drawerApi() {
    var d = window.biesCartDrawer;
    return (d && typeof d.beginOptimisticAdd === 'function' && typeof d.commitAddResponse === 'function') ? d : null;
  }
  function renderAdded() {
    root.innerHTML = '';
    var card = h('div', 'tpp-added');
    card.appendChild(h('div', 'tpp-added__icon', '✓'));
    card.appendChild(h('h3', 'tpp-added__title', 'Tu pack ya está en el carrito'));
    card.appendChild(h('p', 'tpp-added__lead', 'Puedes seguir mirando la tienda o pasar a pagar cuando quieras.'));
    var cta = h('button', 'tpp-build tpp-added__cta', 'Sigue la compra por aquí →'); cta.type = 'button';
    card.appendChild(cta);
    root.appendChild(card);
    cta.addEventListener('click', goToCart);
  }

  // ── Añadir al carrito ──
  // Con SUB_ON e isSub, cada item lleva selling_plan (Club BIES) → el checkout
  // aplica el descuento real del plan y crea el subscription contract.
  // Datos personales del quiz (nombre, email, fecha nac., sexo) van SOLO al
  // identify de Klaviyo — no como line item properties del pedido.
  function addToCart(isSub) {
    if (addToCart._busy) return;
    var asSub = !!(isSub && SUB_ON);
    var items = selected.map(function (hh) {
      var p = byHandle(hh);
      if (!p || !p.vid) return null;
      var it = { id: p.vid, quantity: 1 };
      if (asSub) it.selling_plan = Number(CFG.sellingPlanId);
      return it;
    }).filter(Boolean);
    if (!items.length) return;
    if (items.length < selected.length) { cartError('No hemos podido preparar tu pack completo. Recarga la página e inténtalo de nuevo.'); return; }
    addToCart._busy = true;
    setBuyButtonsDisabled(true);
    var props = { '_bies_pack': 'Tu propio pack', '_perfil': (answers.q1 || '') + '/' + (answers.q2 || ''), '_edad': answers.edad || '' };
    items.forEach(function (it) { it.properties = props; });
    // (8-sep) Mismo patrón que el interceptor de formularios del drawer: abrir
    // AHORA con spinner (antes de la red) y pedir las sections en el propio
    // add.js para que el drawer se pinte con esa única respuesta. Antes: fetch
    // add → fetch /cart.js → processCart → open(), >2s sin feedback en móvil.
    var drawer = drawerApi();
    var token = drawer ? drawer.beginOptimisticAdd() : null;
    var body = { items: items };
    if (drawer) body.sections = drawer.constructor.SECTIONS;
    fetch(CFG.cartUrl.replace(/\/cart$/, '') + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart_add_' + r.status);
      return r.json();
    }).then(function (addData) {
      addToCart._busy = false;
      renderAdded();
      if (drawer) drawer.commitAddResponse(addData, token); else goToCart();
    }).catch(function () {
      addToCart._busy = false;
      setBuyButtonsDisabled(false);
      cartError('No hemos podido añadir tu pack al carrito. Inténtalo de nuevo en unos segundos.');
      if (drawer) drawer.recoverAfterFailedAdd(token).then(function () { drawer.close(); });
    });
  }

  function setBuyButtonsDisabled(disabled) {
    var btns = root ? root.querySelectorAll('.tpp-buy') : [];
    for (var i = 0; i < btns.length; i++) btns[i].disabled = disabled;
  }

  function cartError(msg) {
    if (!root) return;
    var prev = root.querySelector('.tpp-cart-error');
    if (prev && prev.parentNode) prev.parentNode.removeChild(prev);
    var el = h('p', 'tpp-cart-error', msg);
    el.style.cssText = 'text-align:center;color:#b3261e;margin:10px 0 0;font-size:14px;';
    var bar = root.querySelector('.tpp-bar');
    if (bar && bar.parentNode) bar.parentNode.appendChild(el); else root.appendChild(el);
  }

  function init() {
    root = document.querySelector('[data-tpp]');
    if (!root || !CFG.catalog || !CFG.catalog.length) { if (root) root.innerHTML = '<p style="text-align:center;opacity:.6">Catálogo no disponible en este preview.</p>'; return; }
    // ¿Tenemos perfil? → pack automático. Si no → preguntar / que nos cuente.
    var prof = getKnownProfile();
    // Siempre empezamos pidiendo los datos (nombre/email/sexo/fecha nac.); si ya lo sabemos, se rellena solo.
    if (prof) { answers.q1 = prof.q1; answers.q2 = prof.q2; answers.edad = prof.edad || null; answers.sexo = prof.sexo || null; answers.nombre = prof.nombre || ''; answers.email = prof.email || ''; answers.fnac = prof.fnac || null; }
    renderDatos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
